const translation = {
  title: '计算集群',
  create: {
    title: '创建计算集群',
  },
  detail: {
    title: '计算集群详情',
    tabs: {
      detail: '详情',
      servers: '节点',
      queues: '资源队列',
      specs: '资源规格',
      groups: '资源组',
      monitor: '监控',
      server_specs: '节点规格',
      workloads: '工作负载',
    },
  },
  form: {
    name: '集群名称',
    nameTooltip: '计算集群的唯一标识名称，用于在系统中区分不同的集群',
    description: '集群描述',
    descriptionTooltip: '对集群用途、特点等信息的简要描述，便于后续管理',
    type: '集群类型',
    typeTooltip: '选择集群的类型，不同类型决定了集群的管理方式和功能特性',
    status: '集群状态',
    statusTooltip: '集群当前的运行状态，如运行中、已停止等',
    region: '区域',
    regionTooltip: '集群所在的地理区域，影响网络延迟和数据合规性',
    zone: '可用区',
    zoneTooltip: '集群所在的可用区，同区域内不同可用区之间网络互通',
    network: '网络配置',
    networkTooltip: '集群的网络配置信息，包括VPC、子网等设置',
    storage: '存储配置',
    storageTooltip: '集群的存储配置信息，包括存储类型和挂载方式',
    compute: '计算配置',
    computeTooltip: '集群的计算资源配置，包括CPU、GPU和内存等资源信息',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    server_spec: '计算节点规格',

    // 表单字段
    region_name: '区域名称',
    region_name_tooltip: '集群所在区域的标识名称，如 cn-east-1',
    region_alias: '区域别名',
    region_alias_tooltip: '区域的可读别名，如"华东一区"，便于用户识别',
    server: '集群地址',
    server_tooltip: '集群地址，例如：https://192.168.12.11:6443',
    runtime_sock_path: 'Sock',
    runtime_sock_path_tooltip: '容器运行时Sock路径，例如：/var/run/docker.sock',
    certificate: '服务证书',
    certificate_tooltip: 'Kubernetes API Server 的 CA 证书内容，用于验证集群身份',
    user_name: '用户名称',
    user_name_tooltip: '用于连接 Kubernetes 集群的认证用户名',
    user_key: '用户密钥',
    user_key_tooltip: '用于连接 Kubernetes 集群的认证密钥',
    user_certificate: '用户证书',
    user_certificate_tooltip: '用户的客户端证书内容，与用户密钥配合使用进行身份认证',
    user_token: '用户令牌',
    user_token_tooltip: 'Kubernetes ServiceAccount Token，用于集群API认证',
    vip: 'VIP',
    vip_tooltip: '集群流量入口IP或域名',
    harbor_registry: 'Harbor',
    harbor_registry_tooltip: 'Harbor地址，例如：harbor.example.com',
    harbor_username: 'Harbor用户名',
    harbor_username_tooltip: '用于登录 Harbor 镜像仓库的用户名',
    harbor_password: 'Harbor密码',
    harbor_password_tooltip: '用于登录 Harbor 镜像仓库的密码',
    harbor_api_url: 'Harbor API URL',
    harbor_api_url_tooltip: 'Harbor API 的访问地址，例如：https://harbor.example.com/api/v2.0',
    ingress_host: '流量入口',
    ingress_host_tooltip: '集群对外暴露的流量入口域名，外部请求通过该域名访问集群服务',
    internal_ingress_host: '内部流量入口',
    internal_ingress_host_tooltip: '集群内部服务的流量入口域名，仅在内网环境中使用',
    internal_ingress_port: '内部流量入口端口',
    internal_ingress_port_tooltip: '集群内部服务的流量入口端口号',
    use_tls: '是否使用TLS',
    use_tls_tooltip: '启用后，集群服务的流量入口将使用 HTTPS 加密通信',
    use_grafana: '是否使用Grafana',
    use_grafana_tooltip: '启用后，可通过 Grafana 查看集群的监控大盘和可视化报表',
    prometheus_url: 'Prometheus',
    prometheus_url_tooltip: 'Prometheus 监控服务的访问地址，用于采集和查询集群监控指标',
    docker_image: 'Docker镜像',
    docker_image_tooltip: '集群中使用的 Docker CLI 工具镜像，用于构建和管理容器镜像',
    docker_image_placeholder: 'dodocker:23.0.4',
    nerdctl_image: 'Nerdctl镜像',
    nerdctl_image_tooltip: '集群中使用的 Nerdctl 工具镜像，用于 containerd 运行时的镜像管理',
    nerdctl_image_placeholder:
      'ccr.ccs.tencentyun.com/cube-studio/nerdctl:1.7.2',
    cloudshell_image: 'Cloudtty镜像',
    cloudshell_image_tooltip: '用于提供 Web Terminal 功能的 Cloudtty 镜像，支持用户通过浏览器登录容器',
    cloudshell_image_placeholder: '',
    kaniko_image: 'KANIKO镜像',
    kaniko_image_tooltip: '用于在 Kubernetes 中无特权构建容器镜像的 Kaniko 工具镜像',
    kaniko_image_placeholder: 'gcr.io/kaniko-project/executor:v1.6.0',
    data_importer_image: '数据导入镜像',
    data_importer_image_tooltip: '用于将外部数据（如Git仓库）导入到平台存储中的工具镜像',
    data_importer_image_placeholder:
      'registry.cn-hangzhou.aliyuncs.com/trainkr-public/dataset-importer',

    // 操作消息
    create_success: '创建计算集群成功！',
    create_failed: '创建计算集群失败！',
    update_success: '更新计算集群成功！',
    update_failed: '更新计算集群失败！',
  },
  list: {
    title: '计算集群列表',
    create: '创建集群',
    search: '搜索集群',
    filter: '筛选',
    // 表格列标题
    name: '名称',
    status: '状态',
    region: '区域',
    server: 'server',
    username: '用户名',
    default_cluster: '默认集群',
    sock: 'Sock',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',

    // 按钮和操作
    create_cluster: '创建计算集群',
    view_servers: '查看主机',
    edit: '编辑',
    delete: '删除',
    search_placeholder: '搜索',

    // 状态值
    yes: '是',
    no: '否',

    // 操作确认
    delete_confirm: '确认删除',
    delete_confirm_content: '确认删除该集群？',
    delete_success: '删除成功！',
    delete_failed: '删除失败！',
    confirm: '确认',
    cancel: '取消',

    status_values: {
      active: '运行中',
      inactive: '已停止',
      error: '错误',
      pending: '创建中',
      deleting: '删除中',
    },
    actions: {
      view: '查看',
      edit: '编辑',
      delete: '删除',
      start: '启动',
      stop: '停止',
      restart: '重启',
    },
  },
  servers: {
    title: '节点管理',
    add: '添加节点',
    remove: '移除节点',
    // 服务器状态
    status_values: {
      running: '运行中',
      stopped: '已停止',
      error: '错误',
      pending: '创建中',
    },
    // 服务器列表表格列标题
    id: 'ID',
    status: '状态',
    resource_group: '资源组',
    gpu_name: 'GPU型号',
    gpu_num: 'GPU数量',
    gpu_mem: 'GPU内存',
    total_resources: '资源总量',
    available_resources: '可分配资源',
    ip: 'IP',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',
    edit: '编辑',
    // 搜索相关
    search_placeholder: '搜索服务器',

    // 服务器表单字段
    form: {
      name: '名称',
      alias: '别名',
      status: '状态',
      resource_group: '资源组',
      description: '描述',
      gpu_vendor: 'GPU 厂商',
      gpu_name: 'GPU 名称',
      gpu_num: 'GPU 数量',
      gpu_mem: 'GPU 内存',
      gpu_spp: 'GPU SPP',
      gpu_dpp: 'GPU DPP',
      max_cuda: '最大 CUDA 版本',
      pay_price_hourly: '每小时价格',
      cpu_num: 'CPU 数量',
      cpu_name: 'CPU 名称',
      mem_size: '内存大小',
      disk_size: '磁盘大小',
      disk_type: '磁盘类型',
      ip: 'IP 地址',
      labels: '标签',
    },

    // 按钮和操作
    confirm: '确定',
    cancel: '取消',

    // 操作消息
    update_server: '更新计算节点',
    create_server: '创建计算节点',
  },
  queues: {
    title: '资源队列',
    add: '添加队列',
    remove: '移除队列',
    name: '队列名称',
    priority: '优先级',
    status: {
      active: '活跃',
      inactive: '非活跃',
      error: '错误',
    },
    // 队列列表表格列标题
    id: 'ID',
    permission: '权限',
    status_label: '状态',
    state: '运行状态',
    weight: '权重',
    priority_label: '优先级',
    job_status: '任务状态',
    capability: '资源容量',
    allocated: '已分配',
    reservation: '预留资源',
    reclaimable: '资源回收',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',

    // 任务状态
    inqueue: '排队中',
    running: '运行中',
    pending: '等待中',
    completed: '已完成',

    // 按钮和操作
    create_queue: '创建队列',
    edit: '编辑',
    delete: '删除',

    // 操作确认
    delete_confirm: '确认删除',
    delete_confirm_content: '确认删除该队列？',
    delete_success: '删除成功！',
    delete_failed: '删除失败！',

    // 资源回收
    yes: '是',
    no: '否',
  },
  specs: {
    title: '资源规格',
    add: '添加规格',
    remove: '移除规格',
    name: '规格名称',
    cpu: 'CPU',
    memory: '内存',
    gpu: 'GPU',
    storage: '存储',
    // 资源规格列表
    create_resource_spec: '创建资源规格',
    search_placeholder: '搜索',
    // 表格列标题
    id: 'ID',
    gpu_name: 'GPU型号',
    gpu_num: 'GPU数量',
    gpu_mem: 'GPU显存(GB)',
    cpu_num: 'CPU核数',
    mem_size: '内存大小(GB)',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',
    // 操作按钮
    edit: '编辑',
    delete: '删除',
  },
  groups: {
    title: '资源组',
    add: '添加资源组',
    remove: '移除资源组',
    name: '组名称',
    description: '组描述',
    members: '成员',
    // 资源组表单
    form: {
      name: '名称',
      nameTooltip: '资源组的唯一标识名称，用于对集群节点进行分组管理',
      description: '描述',
      descriptionTooltip: '对资源组用途和包含资源的简要描述',
      cluster_id: '集群ID',
      confirm: '确定',
      cancel: '取消',
      create_success: '创建资源组成功！',
      create_failed: '创建资源组失败！',
      update_success: '更新资源组成功！',
      update_failed: '更新资源组失败！',
      create_action: '创建资源组',
      update_action: '更新资源组',
    },
    // 资源组列表
    list: {
      title: '资源组列表',
      create: '创建资源组',
      search: '搜索',
      search_placeholder: '搜索',
      // 表格列标题
      id: 'ID',
      name: '名称',
      description: '描述',
      created_at: '创建时间',
      updated_at: '更新时间',
      operation: '操作',
      // 操作按钮
      edit: '编辑',
      delete: '删除',
      // 操作确认
      delete_confirm: '确认删除',
      delete_confirm_content: '确认删除该资源组？',
      delete_success: '删除成功！',
      delete_failed: '删除失败！',
    },
  },
  monitor: {
    title: '集群监控',
    overview: '概览',
    performance: '性能',
    resources: '资源使用',
    alerts: '告警',
    logs: '日志',
  },
  overview: {
    home: '首页',
    workload: '工作负载',
    storage: '存储资源',
    other: '其它资源',
    containerInstance: '容器实例',
    trainTask: '训练任务',
    inferenceService: '推理服务',
    model: '模型',
    dataset: '数据集',
    image: '容器镜像',
    disk: '存储磁盘',
    repository: '镜像仓库',
    userCenter: '个人中心',
    welcome: '欢迎您使用{{name}}',
  },
  resource_spec_form: {
    cluster_id: '集群ID',
    name: '名称',
    name_tooltip: '资源规格的唯一标识名称，如 gpu-a100-80g-8',
    gpu_name: 'GPU型号',
    gpu_name_tooltip: '显卡型号，如RTX-3090、A100等',
    gpu_name_placeholder: 'RTX-3090',
    gpu_key: 'GPU标识',
    gpu_key_tooltip: 'Kubernetes中用于标识GPU资源的键名，通常为nvidia.com/<型号>',
    gpu_key_placeholder: 'nvidia.com/rtx-3090',
    gpu_num: 'GPU数量',
    gpu_num_tooltip: '该规格包含的GPU数量',
    gpu_mem: 'GPU显存',
    gpu_mem_tooltip: 'GPU显存大小，如24Gi、80Gi等',
    cpu_num: 'CPU核心数',
    cpu_num_tooltip: '该规格包含的CPU核心数量',
    cpu_name: 'CPU型号',
    cpu_name_tooltip: 'CPU型号，如Intel Xeon Gold 6258R等',
    cpu_arch: 'CPU架构',
    cpu_arch_tooltip: 'CPU架构，如amd64、arm64等',
    mem_size: '内存大小',
    mem_size_tooltip: '内存大小，如64Gi、128Gi等',
    system_disk: '系统盘',
    train_template_id: '训练任务模版ID',
    instance_template_id: '容器实例模版ID',
    deployment_template_id: '推理服务模版ID',
    extras: '其它资源',
    extras_tooltip: '额外的资源，如TPU、FPGA等',
    confirm: '确定',
    cancel: '取消',
    create: '创建资源规格',
    update: '更新资源规格',
  },
  server_spec: {
    detail_title: '计算节点规格详情',
    create_title: '创建计算节点规格',
    edit_title: '编辑计算节点规格',
  },
  // ClusterList.tsx
  ClusterList: {
    // Table column headers
    name: '名称',
    status: '状态',
    region: '区域',
    server: '服务器',
    username: '用户名',
    default_cluster: '默认集群',
    sock: '套接字',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',

    // Buttons and actions
    create_cluster: '创建计算集群',
    view_servers: '查看服务器',
    edit: '编辑',
    delete: '删除',
    search_placeholder: '搜索',

    // Status values
    yes: '是',
    no: '否',

    // Action confirmations
    delete_confirm: '确认删除',
    delete_confirm_content: '确定要删除此集群吗？',
    delete_success: '删除成功！',
    delete_failed: '删除失败！',
    confirm: '确认',
    cancel: '取消',
  },

  // ResourceMonitor.tsx
  ResourceMonitor: {
    title: '资源监控',
    compute: '计算资源',
    storage: '存储磁盘',
    harbor: '镜像仓库',
  },
}

export default translation
